import { fetchAPI } from '@bsd/dashboard-toolkit/utils'


export const checkAuth = () => async (dispatch) => {
  dispatch({ type: 'CHECK_AUTH' })
  try {
    await fetchAPI(`/in/check-auth`)
    dispatch({ type: 'CHECK_AUTH_SUCCESS' })
  } catch(error) {
    dispatch({ type: 'CHECK_AUTH_FAIL' })
    throw error
  }
}

export const loginDashboard = (credentials) => async (dispatch) => {
  dispatch({ type: 'LOGIN' })
  try {
    await fetchAPI(`/in/login`, 'POST', credentials)
    dispatch({ type: 'LOGIN_SUCCESS' })
  } catch (error) {
    dispatch({ type: 'LOGIN_FAIL', error })
  }
}

export const logoutDashboard = () => async (dispatch) => {
  dispatch({ type: 'LOGOUT' })
  try {
    await fetchAPI(`/in/logout`, 'POST')
    dispatch({ type: 'LOGOUT_SUCCESS' })
  } catch (error) {
    dispatch({ type: 'LOGOUT_FAIL', error })
  }
}

export const initializeDashboard = () => async (dispatch) => {
  dispatch({ type: 'INIT_DASHBOARD' })
  try {
    dispatch({ type: 'CHECK_LOGIN' })
    await fetchAPI(`/in/check-auth`)
    dispatch({ type: 'CHECK_LOGIN_SUCCESS', categories })

    const profile = await fetchAPI(`/in/profile`)
    const categories = await fetchAPI(`/in/globe3d/geo-categories`)
    const sections = await fetchAPI(`/in/globe3d/geo-sections`)
    dispatch({ type: 'INIT_DASHBOARD_SUCCESS', profile, categories, sections })
  } catch (error) {
    dispatch({ type: 'INIT_DASHBOARD_FAIL', error })
  }
}

export const resetDashboard = () => ({ type: 'RESET_DASHBOARD' })
